<script setup lang="ts">

</script>

<template>
  <div>
    <div class="container wrapper font-Pretendar cola-color text-center">
      <img
        class="img-ss"
        src="../images/bottle-success-page.png"
        alt=""
      >
      <slot />
    </div>

    <div class="tabs-section">
      <!-- Tabs content goes here -->
    </div>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  padding: 150px 0;

  @include media-breakpoint-down(md) {
    padding: 70px 0 200px;
  }
}

.img-ss {
  max-width: 300px;

  @include media-breakpoint-down(md) {
    max-width: 150px;
  }
}
</style>
